import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import cx from 'classnames';
import ShareIcon from 'components/icons/Share';
import MailIcon from 'components/icons/Mail';
import useBreakpoint from 'utils/hooks/useBreakpoint';
import { shareThis, getUrl } from 'utils/shareThis';

import { colors } from 'utils/tailwindColors';

const IconContainer = styled.button`
  width: 2.25rem;
  height: 2.25rem;
`;

const ShareIconContainer = styled(ShareIcon)`
  ${IconContainer}:hover & {
    ${({ color }) => (color === 'blue' ? `color:${colors.white} ` : '')}
  }
`;

const ShareDropIcon = ({ color = 'blue' }) => {
  const [isSharedVisible, setIsSharedVisible] = useState(false);
  const breakpoint = useBreakpoint(
    typeof window !== 'undefined' && window.innerWidth,
  );
  const shareOptionsButtonRef = useRef();
  const isMobile = ['sm', 'xs'].includes(breakpoint);

  return (
    <div
      className={cx(
        'flex flex-col items-center justify-center absolute top-0 right-0',
        {
          'pr-4': isMobile,
        },
      )}
    >
      <IconContainer
        className={cx(
          'flex items-center justify-center rounded-full bg-transparent text-mattamy-blue hover:bg-mattamy-blue hover:text-white cursor-pointer',
          { 'bg-mattamy-blue text-white': isSharedVisible },
        )}
        tabIndex='0'
        onClick={() => {
          setIsSharedVisible(!isSharedVisible);
        }}
        aria-label='Open share options'
        ref={shareOptionsButtonRef}
      >
        <ShareIconContainer
          className={cx('h-5', {
            'text-white': color !== 'blue' || isSharedVisible,
            'text-mattamy-blue': color === 'blue' && !isSharedVisible,
          })}
          color={color}
        />
      </IconContainer>
      {isSharedVisible && (
        <>
          <div
            className='st-custom-button'
            onClick={() => {
              shareThis({
                dataNetwork: 'email',
                dataUrl: getUrl(),
              });
            }}
          >
            <IconContainer
              data-aos='fade-down'
              data-aos-duration='100'
              className='rounded-full bg-mattamy-blue mt-2 flex items-center justify-center'
              aria-label='Share by email'
            >
              <MailIcon className='h-5 w-5 text-white' />
            </IconContainer>
          </div>
        </>
      )}
    </div>
  );
};

export default ShareDropIcon;
